import React from "react";

const SciencePage = () => {
	return <></>;
};

export default SciencePage;
